// source: kevbox/telemetry/v1/health_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.kevbox.telemetry.v1.CheckHealthRequest', null, global);
goog.exportSymbol('proto.kevbox.telemetry.v1.CheckHealthResponse', null, global);
goog.exportSymbol('proto.kevbox.telemetry.v1.HealthCheckResult', null, global);
goog.exportSymbol('proto.kevbox.telemetry.v1.HealthStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.CheckHealthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kevbox.telemetry.v1.CheckHealthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.CheckHealthRequest.displayName = 'proto.kevbox.telemetry.v1.CheckHealthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.CheckHealthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kevbox.telemetry.v1.CheckHealthResponse.repeatedFields_, null);
};
goog.inherits(proto.kevbox.telemetry.v1.CheckHealthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.CheckHealthResponse.displayName = 'proto.kevbox.telemetry.v1.CheckHealthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.HealthCheckResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kevbox.telemetry.v1.HealthCheckResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.HealthCheckResult.displayName = 'proto.kevbox.telemetry.v1.HealthCheckResult';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.CheckHealthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.CheckHealthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.CheckHealthRequest}
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.CheckHealthRequest;
  return proto.kevbox.telemetry.v1.CheckHealthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.CheckHealthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.CheckHealthRequest}
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.CheckHealthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.CheckHealthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckHealthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.CheckHealthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.CheckHealthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    checkResultsList: jspb.Message.toObjectList(msg.getCheckResultsList(),
    proto.kevbox.telemetry.v1.HealthCheckResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.CheckHealthResponse}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.CheckHealthResponse;
  return proto.kevbox.telemetry.v1.CheckHealthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.CheckHealthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.CheckHealthResponse}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (reader.readEnum());
      msg.setServiceStatus(value);
      break;
    case 2:
      var value = new proto.kevbox.telemetry.v1.HealthCheckResult;
      reader.readMessage(value,proto.kevbox.telemetry.v1.HealthCheckResult.deserializeBinaryFromReader);
      msg.addCheckResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.CheckHealthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.CheckHealthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCheckResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.kevbox.telemetry.v1.HealthCheckResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional HealthStatus service_status = 1;
 * @return {!proto.kevbox.telemetry.v1.HealthStatus}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.getServiceStatus = function() {
  return /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthStatus} value
 * @return {!proto.kevbox.telemetry.v1.CheckHealthResponse} returns this
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.setServiceStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated HealthCheckResult check_results = 2;
 * @return {!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.getCheckResultsList = function() {
  return /** @type{!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.kevbox.telemetry.v1.HealthCheckResult, 2));
};


/**
 * @param {!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>} value
 * @return {!proto.kevbox.telemetry.v1.CheckHealthResponse} returns this
*/
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.setCheckResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthCheckResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult}
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.addCheckResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.kevbox.telemetry.v1.HealthCheckResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kevbox.telemetry.v1.CheckHealthResponse} returns this
 */
proto.kevbox.telemetry.v1.CheckHealthResponse.prototype.clearCheckResultsList = function() {
  return this.setCheckResultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.HealthCheckResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.HealthCheckResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.HealthCheckResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    checkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    checkStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    externalName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    externalMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.HealthCheckResult;
  return proto.kevbox.telemetry.v1.HealthCheckResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.HealthCheckResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckId(value);
      break;
    case 2:
      var value = /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (reader.readEnum());
      msg.setCheckStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.HealthCheckResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.HealthCheckResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.HealthCheckResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCheckStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getExternalName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExternalMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string check_id = 1;
 * @return {string}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.getCheckId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult} returns this
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.setCheckId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional HealthStatus check_status = 2;
 * @return {!proto.kevbox.telemetry.v1.HealthStatus}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.getCheckStatus = function() {
  return /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthStatus} value
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult} returns this
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.setCheckStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string external_name = 3;
 * @return {string}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.getExternalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult} returns this
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.setExternalName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string external_message = 4;
 * @return {string}
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.getExternalMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult} returns this
 */
proto.kevbox.telemetry.v1.HealthCheckResult.prototype.setExternalMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.kevbox.telemetry.v1.HealthStatus = {
  HEALTH_STATUS_UNSPECIFIED: 0,
  HEALTH_STATUS_PASS: 10,
  HEALTH_STATUS_FAIL: 40
};

goog.object.extend(exports, proto.kevbox.telemetry.v1);
